import { translateFn } from '../../../../../../../../../utils/translator.helper';
import { ValidationResult } from '../../../../../../../../../ui/gzForm/formField/types/form-validator';
import {
  ContentControlWebAccessRule,
  ContentControlWebAccessRulePermission,
} from '@nirvana/shared/dtos/types/policies/common';

// validate type
export function validatePermission(type: number): ValidationResult {
  for (const exclusionType of Object.values(ContentControlWebAccessRulePermission)) {
    if (type === exclusionType) {
      return {
        valid: true,
      };
    }
  }

  return {
    valid: false,
    error: '',
  };
}

// validate duplicates
export function validateDuplicates(
  exclusionItem: ContentControlWebAccessRule,
  exclusionsInGrid: ContentControlWebAccessRule[]
): ValidationResult {
  const hasDuplicates = exclusionsInGrid.some(
    (exclusionInGrid: ContentControlWebAccessRule) => exclusionInGrid.webAddress === exclusionItem.webAddress
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
